import type { useCallback } from "react";
import { useLayoutEffect, useRef } from "react";
import { useLocation } from "../components/Router/state";

export const useNavigationEffect = (
  callback: ReturnType<typeof useCallback>,
  additionalDependencies?: unknown[]
) => {
  const location = useLocation();
  const previousLocationRef = useRef(location.pathname);

  useLayoutEffect(() => {
    if (previousLocationRef.current !== location.pathname) {
      callback();
    }
    previousLocationRef.current = location.pathname;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, callback, ...(additionalDependencies || [])]);
};
